import { useGetDossierSuggestiesById } from "@/entities/suggestie";
import { Icon, SidebarGroupContent, SidebarGroupLabel } from "@/shared/components";
import { TimelineEmptyMessage, TimelineEntries, TimelineItem } from "@/shared/components/ui/timeline";
import { SuggestieTijdlijnCard } from "./suggestie-tijdlijn-card";

type SuggestiesProps = {
    dossierNummer: string;
};

export function Suggesties({ dossierNummer }: SuggestiesProps) {
    const { data: suggesties, isPending, error } = useGetDossierSuggestiesById(dossierNummer);

    if (isPending) {
        return <p>Suggesties worden geladen...</p>;
    }

    if (error) {
        return <p>Fout bij het laden van Suggesties: {error.message}</p>;
    }

    const filteredSuggesties = suggesties.filter((suggestie) => suggestie.status === "Nieuw");

    return (
        <article className="relative">
            <SidebarGroupLabel className="bg-emphasis-primary mb-2 grid grid-cols-[48px_40px_1fr] px-0">
                <Icon name="light-bulb" className="col-start-2 justify-self-center" />
                Suggesties
            </SidebarGroupLabel>
            <SidebarGroupContent>
                <TimelineEntries className="grid gap-2" data-testid="suggesties-timeline">
                    {!filteredSuggesties.length ? (
                        <TimelineEmptyMessage>Op dit moment geen suggesties</TimelineEmptyMessage>
                    ) : (
                        filteredSuggesties.map((suggestie) => (
                            <TimelineItem key={suggestie.id}>
                                <SuggestieTijdlijnCard suggestie={suggestie} dossierId={dossierNummer} />
                            </TimelineItem>
                        ))
                    )}
                </TimelineEntries>
            </SidebarGroupContent>
        </article>
    );
}
